import { render, staticRenderFns } from "./data.vue?vue&type=template&id=3cee4bb2&"
import script from "./data.vue?vue&type=script&lang=js&"
export * from "./data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports